import LinkButton from "../Buttons/LinkButton";

// This is the hero component for all the consulting pages. It takes in the all the below props.

const ConsultingHero = ({
  title, // Large text in the hero to be displayed
  buttonText, // Text the button should display
  buttonTo = "/contact-us", // the endopoint that the button takes you to (defaults to /contact-us)
  buttonColour = "blue", // Colour of the first button (defaults to "blue")
  button2Text, // Optional second button text
  button2To = "/contact-us", // Optional second button route
  button2Colour = "orange", // Colour of the second button (defaults to "orange")
  bgColor, // Tailwind bg class for the hero (e.g. "bg-orange", "bg-blue")
  imageSrc, // The url of the smallest size image (recomend using 480, 1280, and 1920 but it is flexible).
  imageSrcSet, // All the image urls in a string for each size followed by the screen width (http://url... 480w, etc)
  imageAlt = "", // The alt text for the image
  imageClassName = "", // the extra classes for the image or tailwind styling (it already is set to w-full, h-full and object-cover)
}) => {
  return (
    <section className="flex flex-col items-start w-full mb-16 relative">
      {/* bgColor blends with the image background on larger screens */}
      <div
        className={`mt-24 md:mt-16 w-full h-[400px] md:h-[550px] lg:h-[650px] xl:h-[834px] overflow-hidden rounded-b-[100px] ${bgColor}`}
      >
        <div className="w-full h-full overflow-hidden">
          <img
            src={imageSrc}
            srcSet={imageSrcSet}
            sizes="100vw"
            alt={imageAlt}
            className={`w-full h-full object-cover ${imageClassName}`}
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </div>
      <div className="absolute bottom-16 left-8 md:left-14 lg:bottom-20 flex flex-col items-start gap-4 md:gap-8">
        {/* Text shadow here because Tailwind does not support text shadow without additional plugin */}
        <h1 className="text-3xl md:text-5xl lg:text-7xl xl:text-9xl font-bold font-inter text-white text-left [text-shadow:2px_2px_1px_black]">
          {title}
        </h1>
        <LinkButton
          className="text-sm md:text-md lg:text-[24px] md:px-4 md:py-2 lg:px-6 lg:py-4 border !border-black"
          colour={buttonColour}
          to={buttonTo}
        >
          {buttonText}
        </LinkButton>
        {button2Text && (
          <LinkButton
            className="text-sm md:text-md lg:text-[24px] md:px-4 md:py-2 lg:px-6 lg:py-4 border !border-black"
            colour={button2Colour}
            to={button2To}
          >
            {button2Text}
          </LinkButton>
        )}
      </div>
    </section>
  );
};

export default ConsultingHero;
